// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CorePricingRepoConfig from "./CorePricingRepoConfig.bs.js";

var dummyCreateCampaignResponse = {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "Bangalore Tata Ace core campaign 0",
        "geo_region_id": 3,
        "vehicle_id": 1,
        "start_instant": "2021-03-26",
        "creation_info": {
          "creator": {
            "id": 108,
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1599135249021
        },
        "status": {
          "campaign_status": "scheduled",
          "approval_time": 1616695280949,
          "approver": {
            "id": 107,
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 20000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 350
          },
          "free_duration": 4200000,
          "free_distance_pricing": {
            "free_kms": 1,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 300
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 5,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2600
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 20,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1800
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            }
          ]
        }
      };

var campaignsDummyResponseUsecase2 = {
      "campaigns": [
        {
          "external_id": "00000000-0000-0000-0000-00000000000",
          "name": "sdasd",
          "geo_region_id": 2,
          "vehicle_id": 1,
          "start_date": "2022-12-21",
          "end_date": null,
          "start_instant": 1671561000000,
          "end_instant": null,
          "creation_info": {
            "creator": {
              "first_name": "test",
              "last_name": "test",
              "email": "test@xyz.com"
            },
            "creation_time": 1671351992035
          },
          "status": {
            "campaign_status": "pending"
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 21000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 400
            },
            "free_duration": 4800000,
            "free_distance_pricing": {
              "free_kms": 2,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 400
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2100
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2300
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2500
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 400
                }
              }
            ]
          }
        },
        {
          "external_id": "00000000-0000-0000-0000-00000000000",
          "name": "Test_Ht-campaign_hypertest_48871lc02w5ly",
          "geo_region_id": 2,
          "vehicle_id": 1,
          "start_date": "2022-12-24",
          "end_date": null,
          "start_instant": 1671820200000,
          "end_instant": null,
          "creation_info": {
            "creator": {
              "first_name": "test",
              "last_name": "test",
              "email": "test@xyz.com"
            },
            "creation_time": 1671773693597
          },
          "status": {
            "campaign_status": "pending"
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 22000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 350
            },
            "free_duration": 4200000,
            "free_distance_pricing": {
              "free_kms": 1,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 10,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2030
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 300
                }
              },
              {
                "slab_km": 25,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 2130
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 300
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 1530
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 300
                }
              }
            ]
          }
        },
        {
          "external_id": "00000000-0000-0000-0000-00000000000",
          "name": "jjs_hypertest_92841lc2zrmmn",
          "geo_region_id": 2,
          "vehicle_id": 1,
          "start_date": "2022-12-26",
          "end_date": "2023-01-23",
          "start_instant": 1671993000000,
          "end_instant": 1674412200000,
          "creation_info": {
            "creator": {
              "first_name": "test",
              "last_name": "test",
              "email": "test@xyz.com"
            },
            "creation_time": 1671949842110
          },
          "status": {
            "campaign_status": "scheduled",
            "approval_time": 1671949843454,
            "approver": {
              "first_name": "test",
              "last_name": "test",
              "email": "test@xyz.com"
            }
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 12000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 200
            },
            "free_duration": 240000,
            "free_distance_pricing": {
              "free_kms": 4,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 200
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 8,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 200
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 200
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 200
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 200
                }
              }
            ]
          }
        },
        {
          "external_id": "00000000-0000-0000-0000-00000000000",
          "name": "demo-test-test",
          "geo_region_id": 2,
          "vehicle_id": 1,
          "start_date": "2023-01-24",
          "end_date": null,
          "start_instant": 1674498600000,
          "end_instant": null,
          "creation_info": {
            "creator": {
              "first_name": "test",
              "last_name": "test",
              "email": "test@xyz.com"
            },
            "creation_time": 1674213487668
          },
          "status": {
            "campaign_status": "scheduled",
            "approval_time": 1674213493745,
            "approver": {
              "first_name": "test",
              "last_name": "test",
              "email": "test@xyz.com"
            }
          },
          "core_pricing_structure": {
            "base_fare": {
              "currency": "INR",
              "minor_amount": 12000
            },
            "waiting_rate_per_min": {
              "currency": "INR",
              "minor_amount": 200
            },
            "free_duration": 240000,
            "free_distance_pricing": {
              "free_kms": 4,
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 200
              }
            },
            "distance_time_pricing": [
              {
                "slab_km": 8,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 200
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 200
                }
              },
              {
                "slab_km": 1000000,
                "price_per_km": {
                  "currency": "INR",
                  "minor_amount": 200
                },
                "price_per_min": {
                  "currency": "INR",
                  "minor_amount": 200
                }
              }
            ]
          }
        }
      ]
  };

var dummyConflictingCampaignRes = {
        "type": "conflicting_campaign_found",
        "message": "Campaign id 2 name Bangalore Tata Ace core campaign 1 is already scheduled to go live on 2021-03-26"
      };

var dummyFailingCampaignRes = {
        "type": "campaign_not_approved",
        "message": "Campaign id 31 name Bangalore Tata Ace core campaign 0 is not in pending state"
      };

var dummyDiscardCampaignResponse = {
        "external_id": "00000000-0000-0000-0000-00000000000",
        "name": "Bangalore Tata Ace core campaign 0",
        "geo_region_id": 3,
        "vehicle_id": 1,
        "start_instant": "2021-03-27",
        "creation_info": {
          "creator": {
            "id": 108,
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          },
          "creation_time": 1599135249021
        },
        "status": {
          "campaign_status": "deleted",
          "deletion_time": 1616745007294,
          "deleter": {
            "id": 107,
            "first_name": "test",
            "last_name": "test",
            "email": "test@xyz.com"
          }
        },
        "core_pricing_structure": {
          "base_fare": {
            "currency": "INR",
            "minor_amount": 20000
          },
          "waiting_rate_per_min": {
            "currency": "INR",
            "minor_amount": 350
          },
          "free_duration": 4200000,
          "free_distance_pricing": {
            "free_kms": 1,
            "price_per_min": {
              "currency": "INR",
              "minor_amount": 300
            }
          },
          "distance_time_pricing": [
            {
              "slab_km": 5,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 10,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 2600
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 20,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1300
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 25,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1500
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            },
            {
              "slab_km": 1000000,
              "price_per_km": {
                "currency": "INR",
                "minor_amount": 1800
              },
              "price_per_min": {
                "currency": "INR",
                "minor_amount": 300
              }
            }
          ]
        }
      };

function fetchPricingCampaigns(geo_region_id, vehicle_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: campaignsDummyResponseUsecase2
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignListResponseConverter.execute, result);
                        });
            });
}

function approveCampaign(campaign_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* DataConflict */7,
                              _0: dummyConflictingCampaignRes
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

function deleteCampaign(campaign_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* UnprocessedEntity */2,
                              _0: dummyFailingCampaignRes
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

function discardCampaign(campaign_id, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyDiscardCampaignResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

function createCampaign(campaign_req, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyCreateCampaignResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CorePricingRepoConfig.CampaignUpdateResponseConverter.execute, result);
                        });
            });
}

var CorePricingRepo = {
  fetchPricingCampaigns: fetchPricingCampaigns,
  approveCampaign: approveCampaign,
  deleteCampaign: deleteCampaign,
  discardCampaign: discardCampaign,
  createCampaign: createCampaign
};

export {
  CorePricingRepo ,
  
}
/* CorePricingRepoConfig Not a pure module */
